import { useEffect, useState, RefObject } from 'react';

export function useIntersectionObserver(
  ref: RefObject<Element>,
  options: IntersectionObserverInit,
  delay: number
): [boolean, boolean] {
  const [isVisible, setIsVisible] = useState<boolean>(true);
  const [isInitiallyChecked, setIsInitiallyChecked] = useState<boolean>(false);

  useEffect(() => {
    if (!ref.current) {
      setIsInitiallyChecked(true);
      setIsVisible(false);
      return;
    }

    let timeoutId: NodeJS.Timeout;

    const observer = new IntersectionObserver(entries => {
      const [entry] = entries;
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsVisible(entry.isIntersecting);
        if (!isInitiallyChecked) {
          setIsInitiallyChecked(true);
        }
      }, delay);
    }, options);

    observer.observe(ref.current);

    return () => {
      clearTimeout(timeoutId);
      observer.disconnect();
    };
  }, [ref, options, delay]);

  return [isVisible, isInitiallyChecked];
}
